import apiService from './index'

export const getUserEnvelopes: any = async (limit: number, offset: number, status?: string,docType?:string) => {
    return await apiService.get(`${process.env.REACT_APP_BACKEND_URL_V3}/docusign/envelopes?${(status && status.length > 0) ? `status=${status}&` : ''}${(docType && docType.length > 0) ? `type=${docType}&` : ''}limit=${limit}&offset=${offset}`)
}

export const downloadEnvelope: any = async (envelopeId: string) => {
    return await apiService.get(`${process.env.REACT_APP_BACKEND_URL_V3}/docusign/envelope/${envelopeId}/documents/download`, {
        responseType: 'blob'
    },)
}

export const sendEnvelope: any = async (payload: any) => {
    return await apiService.post(`${process.env.REACT_APP_BACKEND_URL_V3}/docusign/envelope`, payload)
}
export const prepareEnvelope: any = async (payload: any) => {
    return await apiService.post(`${process.env.REACT_APP_BACKEND_URL_V3}/docusign/prepare-envelope`, payload)
}

export const resendEnvelope: any = async (envelopeId: string) => {
    return await apiService.post(`${process.env.REACT_APP_BACKEND_URL_V3}/docusign/envelope/${envelopeId}/resend`)
}

export const voidEnvelope: any = async (envelopeId: string, payload: any) => {
    return await apiService.post(`${process.env.REACT_APP_BACKEND_URL_V3}/docusign/envelope/${envelopeId}/void`, payload)
}

export const getSenderUrl: any = async (payload: any) => {
    return await apiService.post(`${process.env.REACT_APP_BACKEND_URL_V3}/docusign/envelope/sender-url`, payload)
}
export const getSignerUrl: any = async (payload: any) => {
    return await apiService.post(`${process.env.REACT_APP_BACKEND_URL_V3}/docusign/envelope/signing-url`, payload)
}
export const getRecipients : any = async (envelopeId: string) => {
    return await apiService.get(`${process.env.REACT_APP_BACKEND_URL_V3}/docusign/envelope/${envelopeId}/recipients`)
}